import script from "./teamLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./teamLink.vue?vue&type=script&setup=true&lang=ts"

import "./teamLink.vue?vue&type=style&index=0&id=ed04d9ec&lang=less"

const __exports__ = script;

export default __exports__